import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('batch_payment_creation'),
    title: defineMessage('requesters_can_combine__ch_payment_for_approval'),
    paymentCreation: defineMessage('payment_creation'),
    description: defineMessage('add_users_authorised_to_approval_in_approvalmax_1'),
};
